import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M44.9 45H34.4V31.6c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3V45zm-8-2.5h5.6V31.6c0-1.5-1.3-2.8-2.8-2.8s-2.8 1.3-2.8 2.8v10.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M36.9 45H26.3V31.6c0-2.9 2.4-5.3 5.3-5.3s5.3 2.4 5.3 5.3V45zm-8.1-2.5h5.6V31.6c0-1.5-1.3-2.8-2.8-2.8s-2.8 1.3-2.8 2.8v10.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M9.3 45C4.2 45 0 40.8 0 35.7s4.2-9.3 9.3-9.3 9.3 4.2 9.3 9.3S14.5 45 9.3 45zm0-16.2c-3.8 0-6.8 3.1-6.8 6.8s3.1 6.8 6.8 6.8c3.8 0 6.8-3.1 6.8-6.8s-3-6.8-6.8-6.8z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 9.3,
			cy: 35.7,
			r: 4.2
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M10.6 27.3H8.1v-6.4c0-2.2 1.8-3.9 4-3.9h3.5c.8 0 1.4-.7 1.4-1.5v-4.8h2.5v4.8c0 2.2-1.8 4-3.9 4H12c-.8 0-1.5.7-1.5 1.4v6.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M40.9 27.3h-2.5v-6.4c0-.8-.7-1.4-1.5-1.4h-8.3c-2.2 0-3.9-1.8-3.9-4v-4.8h2.5v4.8c0 .8.7 1.5 1.4 1.5H37c2.2 0 4 1.8 4 3.9v6.4z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 30.3,
			y: 18.2,
			className: "icon-fill-primary",
			width: 2.5,
			height: 9.2
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M35.9 11.8H9.1V0h26.8v11.8zM11.6 9.3h21.8V2.5H11.6v6.8z"
		})
	]
});
export default SvgIcon;
